module.exports = __webpack_public_path__ + "img/5.7b362e88.svg";